import { Action } from "@ngrx/store";
import { isLocalStorageSupported } from "@obg/ngx.global";
import { addMilliseconds, isBefore } from "date-fns";
import { isEqual, isFunction, omit } from "lodash-es";

import { REHYDRATE_ACTION_TYPE } from "./rehydrate.action";
import { Rehydrate, RehydrateOptions, RehydrateState } from "./rehydrate.model";

export const rehydrate: Rehydrate = (reducer: any) => {
	let isRehydrated = false;
	if (!isLocalStorageSupported()) {
		return reducer;
	}

	return (state: RehydrateState, action: Action) => {
		let options: RehydrateOptions<any> = isFunction(reducer.prototype.rehydrateOptions)
			? reducer.prototype.rehydrateOptions()
			: reducer.prototype.rehydrateOptions;

		if (!options?.name) {
			// eslint-disable-next-line no-console
			console.warn("rehydrate 'rehydrateOptions.name' must be provided!", { reducer: reducer.name });
			options = { ...options, name: reducer.name };
		}

		// if rehydrate action is fired, return state from localstorage
		if (!isRehydrated && action.type === REHYDRATE_ACTION_TYPE.rehydrateGenerate) {
			isRehydrated = true;
			const persistedStateValue = localStorage.getItem(options.name);
			if (persistedStateValue) {
				let persistState = { ...state, ...JSON.parse(persistedStateValue) };

				if (persistState.$modifiedDate && options.maxAge) {
					const expiryDate = addMilliseconds(persistState.$modifiedDate, options.maxAge);

					if (isBefore(expiryDate, Date.now())) {
						localStorage.removeItem(options.name);

						// safari workaround
						// TODO: investigate better implementation JIRA: OBGB-3033
						sessionStorage.removeItem(options.name);
						return reducer(state, action);
					}
				}

				persistState = omit(persistState, "$modifiedDate");
				return reducer(persistState, {});
			}
		}

		// calculate next state based on action
		const nextState = reducer(state, action);
		if (state && nextState && !isEqual(nextState, state)) {
			let persistState = nextState;
			if (options.excludeProps) {
				persistState = omit(nextState, options.excludeProps);
			}

			if (options.maxAge) {
				persistState.$modifiedDate = Date.now();
			}

			try {
				// todo: use cache factory when available out of angular scope
				const value = JSON.stringify(persistState);
				localStorage.setItem(options.name, value);

				// safari workaround
				// TODO: investigate better implementation JIRA: OBGB-3033
				sessionStorage.setItem(options.name, value);
			} catch (error) {
				// todo: use logger when available out of angular scope
				// eslint-disable-next-line no-console
				console.error(error);
			}
		}
		// return nextState as normal when not rehydrate action
		return nextState;
	};
};
